module.exports = __webpack_public_path__ + "img/printWhite.c5205af5.svg";